import React, { FC } from 'react';

import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';

type IButtonLink = {
  to: string;
  text: string;
  border?: boolean;
};

const ButtonLink: FC<IButtonLink> = ({ to, text, border }) => (
  <Button
    component={RouterLink}
    to={to}
    variant='outlined'
    sx={{
      bgcolor: border ? 'white' : 'primary.main',
      borderRadius: '10px',
      textTransform: 'capitalize',
      color: 'text.secondary',
      padding: '6px 8px',
      fontSize: '16px',
      width: '100%',
      height: '60px',
      boxShadow: 'none',
      fontWeight: 600,
      border: 0,
      '&': { textTransform: 'unset !important' },
      '&:hover': {
        border: 0,
        bgcolor: 'primary.dark',
      },
    }}
  >
    {text}
  </Button>
);
export default ButtonLink;
